<template>
  <div>
    <navbar></navbar>
    <transition name="page" mode="out-in">
      <router-view :key="$route.fullPath"></router-view>
    </transition>
    <footer-section></footer-section>
    <a href="#" id="toTop"
       :style="{ display: scrolledDown ? 'inline' : 'none' }"
       @click.prevent="scrollToTop()">
      <span id="toTopHover" style="opacity: 0;"></span>
      <i class="icon-angle-up"></i>
    </a>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
// import { mapMutations } from 'vuex'
import Navbar from './components/utilities/Navbar'
import FooterSection from './components/utilities/FooterSection'

export default {
  name: 'App',
  components: { Navbar, FooterSection },
  computed: {},
  methods: {
    handleScroll () {
      this.scrolledDown = window.scrollY > 50
    },
    scrollToTop () {
      // todo: test devices
      const c = document.documentElement.scrollTop || document.body.scrollTop
      if (c > 0) {
        window.requestAnimationFrame(this.scrollToTop)
        // for slower motion, increase the hardcoded number 8
        window.scrollTo(0, c - c / 8)
      }
    }
  },
  data () {
    return {
      scrolledDown: false
    }
  },
  created: function () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style>

  .page-enter-active, .page-leave-active {
    transition: opacity .5s;
  }
  .page-enter, .page-leave-to {
    opacity: 0;
  }
</style>
